<template>
    <div >
        <table class="table is-fullwidth" v-if="bundles.length > 0">
              <thead>
                
                <th>Qty/Size</th>
                <th>Received</th>
                <th>On Floor</th>
                <th>Off Floor</th>
              </thead>

              <tbody>
                <tr v-for="row in bundles" :key="row.id">
                  
                  <td>{{ row.qty}} x {{ row.size_name}}</td>
                    <td>
                      
                      <span v-if="row.received==1">{{ row.date_received }}</span>
                    </td>
                    <td>
                      <span v-if="row.on_factory_floor==1">{{ row.date_on_factory_floor }}</span>
                      
                    </td>
                    <td>
                      
                      <span v-if="row.off_factory_floor==1">{{ row.date_off_factory_floor }}</span>
                    </td>
                </tr>
              </tbody>
          </table>
    </div>
   </template>
    
<script>
   export default {
    props: ['bundles']
   }
</script>